// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "d2091a501b86cb4c","396": "e24e39b9a379bdee","460": "e6e7a8780375018a","917": "fba395c4fb731efe","985": "c5f103fb29f0da7b",}[chunkId] + ".chunk.js"
}